import { render } from "./NewPlanPage.vue?vue&type=template&id=2c08d22f"
import script from "./NewPlanPage.vue?vue&type=script&lang=js"
export * from "./NewPlanPage.vue?vue&type=script&lang=js"

import "./NewPlanPage.vue?vue&type=style&index=0&id=2c08d22f&lang=css"

import exportComponent from "/opt/1psim/portal_test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__